module.exports = __webpack_public_path__ + "static/media/img-ovato-coin-perspective-new.430207e3.pdf";